export const ErrorMessages: {[k: string]: Error} = {
    INVALIDCREDENTIALS: {
        code: 'E001',
        message: $localize`:Generic.Errors.CredentialsNotValid|Label for credential not valid error@@Generic.Errors.CredentialsNotValid:Credenziali non valide`,
    },
    INVALIDOTP: {
        code: 'E002',
        message: $localize`:Generic.Errors.OTPnotValid|Label for otp not valid error@@Generic.Errors.OTPnotValid:Codice OTP non verificato`,
    },
    INVALIDPASSWORD: {
        code: 'E003',
        message: $localize`:Generic.Errors.PasswordNotValid|Label for passwordNotValid not valid error@@Generic.Errors.PasswordNotValid:Password non conforme ai requisiti di sicurezza`,
    },
    TOOMANYAUTHENTICATION: {
        code: 'E004',
        message: $localize`:Generic.Errors.BlockedUser|Label for blocked user error@@Generic.Errors.BlockedUser:La tua utenza risulta momentaneamente bloccata per motivi di sicurezza, si prega di riprovare più tardi`,
    },
    TOOMANYOTP: {
        code: 'E005',
        message: $localize`:Generic.Errors.MaxRetry|Label for max retry error@@Generic.Errors.MaxRetry:Numero di tentativi massimo raggiunto, si prega di riprovare più tardi`,
    },
    INVALIDERCCODE: {
        code: 'E006',
        message: $localize`:Generic.Errors.ERCNotValid|Label for password not valid error@@Generic.Errors.ERCNotValid:Codice di emergenza non valido`,
    },
    INVALIDEMAIL: {
        code: 'E007',
        message: $localize`:Generic.Errors.InvalidEmail|Label for invalid email error@@Generic.Errors.InvalidEmail:La tua email risulta non verificata. Si prega di confermarla tramite il link inviato all\'indirizzo specificato.`,
    },
    INVALIDSESSIONID: {
        code: 'E008',
        message: $localize`:Generic.Errors.InvalidSession|Label for invalid session error@@Generic.Errors.InvalidSession:La tua sessione è scaduta.`,
    },
    INVALIDNEWEMAIL: {
        code: 'E009',
        message: $localize`:Generic.Errors.InvalidNewEmail|Label for ivalid new email error@@Generic.Errors.InvalidNewEmail:L\'email che stai cercando di verificare è errata.`,
    },
    INVALIDREQUESTSTATUS: {
        code: 'E010',
        message: $localize`:Generic.Errors.InvalidRequestStatus|Label for invalid request status error@@Generic.Errors.InvalidRequestStatus:Lo stato della richiesta non permette di effettuare l\'operazione`,
    },
    INVALIDIDENTITYSTATUS: {
        code: 'E011',
        message: $localize`:Generic.Errors.InvalidIdentityStatus|Label for invalid identity status error@@Generic.Errors.InvalidIdentityStatus:Lo stato dell\'identità non permette di effettuare l\'operazione`,
    },
    INVALIDFISCALCODE: {
        code: 'E012',
        message: $localize`:Generic.Errors.InvalidFiscalCode|Label for invalid fiscal code error@@Generic.Errors.InvalidFiscalCode:Codice fiscale inserito non valido`,
    },
    INVALIDDOCUMENTID: {
        code: 'E013',
        message: $localize`:Generic.Errors.InvalidDocumentID|Label for invalid document ID error@@Generic.Errors.InvalidDocumentID:Il documento a cui stai cercando di accedere è inesistente`,
    },
    DUPLICATEDPHONENUMBER: {
        code: 'E014',
        message: $localize`:Generic.Errors.DuplicatedPhone|Label for duplicated phone number error@@Generic.Errors.DuplicatedPhone:Il numero di telefono è già associato ad una entità`,
    },
    DUPLICATEDEMAIL: {
        code: 'E015',
        message: $localize`:Generic.Errors.DuplicatedEmail|Label for duplicated email error@@Generic.Errors.DuplicatedEmail:L\'email è già associata ad una entità`,
    },
    UNKNOWN: {
        code: 'E016',
        message: $localize`:Generic.Errors.Unknown|Label for unknown error@@Generic.Errors.Unknown:Errore sconosciuto`,
    },
    INVALID_DATA_ENTERED: {
        code: 'E017',
        message: $localize`:@@Generico.Errors.InvalidDataEntered:Dati immessi non corretti`,
    },
    OTP_REQUESTED: {
        code: 'E018',
        message: $localize`:Generic.Errors.OTPrequest|Label for otp request error@@Generic.Errors.OTPrequest:Per proseguire è necessario inserire l'OTP`,
    },
    INCORRECT_PARAMETERS: {
        code: 'E019',
        message: $localize`:Generic.Errors.IncorrectParameters|Label for incorrect parameters error@@Generic.Errors.IncorrectParameters:Uno o più parametri sono errati. Verificare i dati inseriti`,
    },
    TOO_SIMILAR_PASSWORD: {
        code: 'E020',
        message: $localize`:Generic.Errors.TooSimilarPassword|Label for password too similar to its previous error@@Generic.Errors.TooSimilarPassword:Password troppo simile alle precedenti`,
    },
    EXPIRED_PASSWORD: {
        code: 'E021',
        message: $localize`:Generic.Errors.ExpiredPassword|Label for expired password error@@Generic.Errors.ExpiredPassword:Password scaduta`,
    },
    EXISTING_CREDENTIALS: {
        code: 'E022',
        message: $localize`:Generic.Errors.ExistingCredential|Label for existing credential error@@Generic.Errors.ExistingCredential:L'identità con le credenziali inserite risulta già esistente`,
    },
    UNHAUTORIZED_USER: {
        code: 'E023',
        message: $localize`:Generic.Errors.UnhautorizedUser|Label for existing credential error@@Generic.Errors.UnhautorizedUser:L'identità con le credenziali inserite risulta già esistente`,
    },
    EXISTING_DOCUMENT: {
        code: 'E024',
        message: $localize`:Generic.Errors.ExistingDocument|Label for existing document error@@Generic.Errors.ExistingDocument:Il documento risulta essere esistente`,
    },
    CONTRACT_ABSENT: {
        code: 'E026',
        message: $localize`:Generic.Errors.ContractAbsent|Label for absent contract error@@Generic.Errors.ContractAbsent:Contratto assente`,
    },
    FISCALCODE_FRONT_ABSENT: {
        code: 'E027',
        message: $localize`:Generic.Errors.FiscalCodeFrontAbsent|Label for absent fiscal code front error@@Generic.Errors.FiscalCodeFrontAbsent:Fronte del codice fiscale assente`,
    },
    FISCALCODE_REAR_ABSENT: {
        code: 'E028',
        message: $localize`:Generic.Errors.FiscalCodeRearAbsent|Label for absent fiscal code rear error@@Generic.Errors.FiscalCodeRearAbsent:Retro del codice fiscale assente`,
    },
    IDENTITYCARD_FRONT_ABSENT: {
        code: 'E029',
        message: $localize`:Generic.Errors.IdentityCardFrontAbsent|Label for absent identity card front error@@Generic.Errors.IdentityCardFrontAbsent:Fronte del documento d'identità assente`,
    },
    IDENTITYCARD_REAR_ABSENT: {
        code: 'E030',
        message: $localize`:Generic.Errors.IdentityCardRearAbsent|Label for absent identity card rear error@@Generic.Errors.IdentityCardRearAbsent:Retro del documento d'identità assente`,
    },
    CONSENT_ABSENT: {
        code: 'E032',
        message: $localize`:Generic.Errors.ConsentAbsent|Label for absent consent error@@Generic.Errors.ConsentAbsent:Consenso firmato della persona giuridica assente`,
    },
    INCORRECT_ACTIVATION_DATA: {
        code: 'E033',
        message: $localize`:Generic.Errors.IncorrectActivationData|Label for incorrect activation data error@@Generic.Errors.IncorrectActivationData:I dati inseriti non coincidono con quelli associati alla richiesta`,
    },
    UNHEXISTING_DRAFT: {
        code: 'E034',
        message: $localize`:Generic.Errors.UnhexistingDraft|Label for unhexisting draft error@@Generic.Errors.UnhexistingDraft:La bozza risulta inesistente nel dominio dell'organizzazione`,
    },
    MAX_OTP_RETRIES: {
        code: 'E041',
        message: $localize`:Generic.Errors.MaxOTPRetries|Label for max otp retries error@@Generic.Errors.MaxOTPRetries:Il numero massimo di tentativi per la conferma dell'OTP è stato raggiunto`,
    },
    UNSUPPORTED_DOCUMENT: {
        code: 'E042',
        message: $localize`:Generic.Errors.UnsupportedDocument|Label for unsupported document error@@Generic.Errors.UnsupportedDocument:Il formato del file non è valido`,
    },
    UNSUPPORTED_DOCUMENT_TYPE: {
        code: 'E043',
        message: $localize`:Generic.Errors.UnsupportedDocumentType|Label for unsupported document error@@Generic.Errors.UnsupportedDocumentType:La tipologia del documento non è valida`,
    },
    UNHEXISTING_REQUEST: {
        code: 'E045',
        message: $localize`:Generic.Errors.UnhexistingRequest|Label for unhexisting request error@@Generic.Errors.UnhexistingRequest:La richiesta risulta inesistente nel dominio dell'organizzazione`,
    },
    UNSUPPORTED_REQUEST_STATE: {
        code: 'E046',
        message: $localize`:Generic.Errors.UnsupportedRequestState|Label for unsupported request state error@@Generic.Errors.UnsupportedRequestState:Lo stato della richiesta non consente il suo annullamento`,
    },
    INVALID_DRAFT_STATE: {
        code: 'E049',
        message: $localize`:Generic.Errors.InvalidDraftState|Label for invalid draft state error@@Generic.Errors.InvalidDraftState:Lo stato della bozza risulta invalido per l'operazione richiesta`,
    },
    ONEPLATFORM_IMPOSSIBLE_ISTANCE: {
      code: 'E053',
      message: $localize`:Generic.Errors.OnePlatformImpossibleIstance|Label for OnePlatform impossible istance error@@Generic.Errors.OnePlatformImpossibleIstance:Non risulta possibile istanziare una sessione SPID con il servizio OnePlatform.`,
    },
    ONEPLATFORM_EXISTING_REQUEST: {
      code: 'E054',
      message: $localize`:Generic.Errors.OnePlatformExistingRequest|Label for OnePlatform existing request error@@Generic.Errors.OnePlatformExistingRequest:Risulta impossibile creare la richiesta perchè esiste già una sessione con il codice fiscale inserito presso il servizio OnePlatform.`,
    },
    REJECT_SCIPAFI_CONTROL: {
      code: 'E066',
      message: $localize`:@@Generic.Errors.RejectScipafiControl:La verifica scipafi presenta un esito negativo.`,
    },
    GENERIC_ERROR_SCIPAFI_CONTROL: {
      code: 'E067',
      message: $localize`:@@Generic.Errors.ExpiredPassword:Impossibile eseguire la verifica scipafi.`,
    },
    ALREADY_USED_EMAIL: {
        code: 'E103',
        message: $localize`:Generic.Errors.AlreadyUsedEmail|Label for already used email error@@Generic.Errors.AlreadyUsedEmail:L'email è già associata ad un'altra identità`,
    },
    TOO_MANY_REQUEST: {
        code: 'X429',
        message: $localize`:Generic.Errors.TooManyRequest|Label for password too many requests error@@Generic.Errors.TooManyRequest:Sono arrivate troppe richieste al server`,
    },
    UNKNOWN_INTERMEDIATE: {
        code: '0000',
        message: $localize`:Generic.Errors.Unknown|Label for unknown error@@Generic.Errors.Unknown:Errore sconosciuto`,
    },
    UNAUTHORIZED: {
        code: 'X401',
        message: $localize`:Generic.Errors.Unauthorized|Label for unauthorized error@@Generic.Errors.Unauthorized:Accesso non autorizzato`,
    },
    FORBIDDEN: {
        code: 'X403',
        message: $localize`:Generic.Errors.Forbidden|Label for forbidden error@@Generic.Errors.Forbidden:Accesso non consentito`,
    },
    NOT_FOUND: {
        code: 'X404',
        message: $localize`:Generic.Errors.NotFound|Label for not found error@@Generic.Errors.NotFound:Pagina non trovata`,
    },

}

import { Injectable, } from '@angular/core';
@Injectable({
    providedIn: 'root',
})
export class ErrorService {

    errorArray = [
        ErrorMessages.DUPLICATEDEMAIL,
        ErrorMessages.DUPLICATEDPHONENUMBER,
        ErrorMessages.INVALIDCREDENTIALS,
        ErrorMessages.INVALIDDOCUMENTID,
        ErrorMessages.INVALIDEMAIL,
        ErrorMessages.INVALIDERCCODE,
        ErrorMessages.INVALIDFISCALCODE,
        ErrorMessages.INVALIDIDENTITYSTATUS,
        ErrorMessages.INVALIDNEWEMAIL,
        ErrorMessages.INVALIDOTP,
        ErrorMessages.INVALIDPASSWORD,
        ErrorMessages.MAX_OTP_RETRIES,
        ErrorMessages.INVALIDREQUESTSTATUS,
        ErrorMessages.INVALIDSESSIONID,
        ErrorMessages.TOOMANYAUTHENTICATION,
        ErrorMessages.TOOMANYOTP,
        ErrorMessages.UNKNOWN,
        ErrorMessages.UNKNOWN_INTERMEDIATE,
        ErrorMessages.UNAUTHORIZED,
        ErrorMessages.FORBIDDEN,
        ErrorMessages.NOT_FOUND,
        ErrorMessages.TOO_SIMILAR_PASSWORD,
        ErrorMessages.EXPIRED_PASSWORD,
        ErrorMessages.TOO_MANY_REQUEST,
        ErrorMessages.UNHAUTORIZED_USER,
        ErrorMessages.EXISTING_CREDENTIALS,
        ErrorMessages.UNHEXISTING_DRAFT,
        ErrorMessages.INCORRECT_PARAMETERS,
        ErrorMessages.INVALID_DRAFT_STATE,
        ErrorMessages.EXISTING_DOCUMENT,
        ErrorMessages.UNSUPPORTED_DOCUMENT,
        ErrorMessages.UNSUPPORTED_DOCUMENT_TYPE,
        ErrorMessages.UNHEXISTING_REQUEST,
        ErrorMessages.UNSUPPORTED_REQUEST_STATE,
        ErrorMessages.EXISTING_DOCUMENT,
        ErrorMessages.CONTRACT_ABSENT,
        ErrorMessages.FISCALCODE_FRONT_ABSENT,
        ErrorMessages.FISCALCODE_REAR_ABSENT,
        ErrorMessages.IDENTITYCARD_FRONT_ABSENT,
        ErrorMessages.IDENTITYCARD_REAR_ABSENT,
        ErrorMessages.CONSENT_ABSENT,
        ErrorMessages.INCORRECT_ACTIVATION_DATA,
        ErrorMessages.ALREADY_USED_EMAIL,
        ErrorMessages.ONEPLATFORM_IMPOSSIBLE_ISTANCE,
        ErrorMessages.ONEPLATFORM_EXISTING_REQUEST,
        ErrorMessages.INVALID_DATA_ENTERED,
        ErrorMessages.REJECT_SCIPAFI_CONTROL,
        ErrorMessages.GENERIC_ERROR_SCIPAFI_CONTROL,
    ];

    getErrorList(): Error[] {
        return this.errorArray;
    }

    getErrorBycode(code: string): Error {
        const genericError = {code, message: `:@@Generic.GenericError:Errore generico`} as Error;
        return this.errorArray.find(x => x.code === code) ?? genericError;
    }
}

export interface Error {
    code: string;
    message: string;
}
